import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import style from './style.css';

const NavBar = ({ username, isAuthenticated, onLogout }) => {
  return (
    <nav className={ style.navBar }>
      <ul className={ style.list }>
        {
          username
            ? (
              <li className={ style.item }>
                <span className={ style.text }> { username }</span>
              </li>
            )
            : (
              null
            )
        }
        <li className={ style.item }>
          {
            isAuthenticated
              ? (
                <button className={ style.button } onClick={ onLogout }>Logga ut</button>
              )
              : (
                <Link className={ style.link }to="/logga-in">Logga in</Link>
              )
          }
        </li>
      </ul>
    </nav>
  );
};

NavBar.propTypes = {
  username: PropTypes.string,
  isAuthenticated: PropTypes.bool.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default NavBar;



// WEBPACK FOOTER //
// ./client/src/components/nav-bar/index.js